import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { Formik, Form, Field } from 'formik'
import yup from 'yup'
import { withRouter } from 'react-router-dom'

import Button from '@components/Button'
import FormError from '@components/FormError'
import Input from '@components/Form/Input'
import PasswordStrength from '@components/PasswordStrength'
import SidePanel from './SidePanel'
import Logo from './SidePanel/logo.js'

class ResetPassword extends Component {
  static propTypes = {
    userStore: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.shape({
      params: PropTypes.shape({
        token: PropTypes.string
      }).isRequired,
      url: PropTypes.string
    }).isRequired,

    // true if the user is invited to set password & join the platform
    setPassword: PropTypes.bool
  }

  state = { error: null }

  submitForm = ({ password }, actions) => {
    const { userStore, match } = this.props
    const token = match.params.token
    const formData = { token, password }

    return userStore
      .resetPassword(formData)
      .then(user => {
        this.props.history.push('/auth/reset-password-success', {
          setPassword: this.props.setPassword
        })
      })
      .catch(({ message }) => {
        this.setState({ error: message })
        actions.setSubmitting(false)
      })
  }

  render () {
    return (
      <div>
        <Formik
          initialValues={{
            password: '',
            passwordRepeat: ''
          }}
          validationSchema={getValidationSchema()}
          onSubmit={this.submitForm}
          render={form => (
            <div className='auth'>
              <SidePanel />
              <div className='expert-form-login'>
                <Logo className='auth-form-logo' />
                <h1 className='expert-form-login__title'>
                  {this.props.setPassword ? 'Set password' : 'Reset password'}
                </h1>
                <FormError error={this.state.error} />
                <Form
                  className='expert-form-login__form'
                  onSubmit={form.handleSubmit}
                >
                  <Field
                    isLogin
                    name='password'
                    label='Password'
                    type='password'
                    component={Input}
                  />
                  <PasswordStrength password={form.values.password} />
                  <Field
                    isLogin
                    name='passwordRepeat'
                    label='Repeat password'
                    type='password'
                    component={Input}
                  />
                  <div className='expert-form-login__input-group p-t p-b'>
                    <Button
                      primary
                      submit
                      onClick={this.onSubmit}
                      disabled={form.isSubmitting}
                    >
                      {this.props.setPassword
                        ? 'SET PASSWORD'
                        : 'RESET PASSWORD'}
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          )}
        />
      </div>
    )
  }
}

export default withRouter(inject('userStore')(observer(ResetPassword)))

function getValidationSchema () {
  return yup.object().shape({
    password: yup
      .string()
      .required('Password is required')
      .min(8, 'Password must be at least 8 characters long')
      .matches(
        /(?=.*[0-9].*)(?=.*[a-z].*)/,
        'Password must contain at least one letter and number'
      ),
    passwordRepeat: yup
      .string()
      .required('Password is required')
      .oneOf([yup.ref('password'), null], 'Passwords must match')
  })
}
